<script>
	import { VIEW } from './stores.js';
	import Header from './Header/Header.svelte';
	import Footer from './Footer/Footer.svelte';
	import Map from './Map/Map.svelte';
	import Table from './Table/Table.svelte';
	import Modal from 'svelte-simple-modal';

  let isMap;
  VIEW.subscribe(value => {
    isMap = value;
  });
</script>

<style type="text/scss" global>
	@import "./styles/base";
</style>

<div class="wrapper">
	<Header />
	<Modal>
		{#if isMap}
			<Map />
		{:else}
			<Table />
		{/if}
	</Modal>
	<Footer />
</div>
